import StoredLayout from '../../layouts/StoredLayout'
import Modals from './Modals'
export default StoredLayout(Modals)



// WEBPACK FOOTER //
// ./src/ui-elements/modals/index.js